import {Tag} from '@web-libs/core/tags/api/tags.types';
import {CmsPageType} from '@web-libs/features/cms/domain/cms.types';

export const getCmsPageTagForInstitution = (institutionId: string,
                                            cmsPageType: CmsPageType): Tag => {
    return {
        value: `institutions/${institutionId}/cms/pages/type/${cmsPageType}`,
    };
};
